import { useState } from 'react';
import {
    Typography,
    Box,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Button,
} from '@mui/material';
import Declined from './Declined';
import { useSelector } from 'react-redux';

const OfferRejected = ({ mobileView, onConfirm }) => {
    const [reason, setReason] = useState('');
    const [comment, setComment] = useState('');
    const [reasonSubmit, setReasonSubmit] = useState(false);
    const reasons = ['Not happy with offer', 'Got better opportunity', 'Personal reason', 'Other'];
    const currentStatus = useSelector((state) => state?.candidateState.candidateInfo.info);
    const handleReasonChange = (event) => {
        const { value } = event.target;
        setReason(value);
    };

    const handleSubmit = () => {
        setReasonSubmit(true);
        onConfirm(`${reason} - ${comment}`);
    };
    const handleComment = (e) => {
        setComment(e.target.value);
    };
    const checkDeclined = () => {
        return (
            currentStatus === 'Offer Declined' ||
            currentStatus === 'Offer declined after Accepted' ||
            currentStatus === 'Declined after Joining Confirm' ||
            reasonSubmit
        );
    };
    return (
        <div>
            {checkDeclined() ? (
                <Declined />
            ) : (
                <>
                    <Typography variant='h6' component='h1' color='primary'>
                        Offer Rejected!
                    </Typography>
                    <Typography variant='body2' component='p' sx={{ px: 3, py: 2 }}>
                        We respect your decision. It would be great if you can tell us the reason of
                        rejecting the offer, to help us better understand. Wish you all the best for
                        your future.
                    </Typography>
                    <Box
                        display='flex'
                        flexDirection='column'
                        justifyContent='center'
                        alignItems='center'
                    >
                        <RadioGroup
                            row={!mobileView ? true : false}
                            value={reason}
                            onChange={handleReasonChange}
                        >
                            {reasons.map((item) => (
                                <FormControlLabel
                                    key={item}
                                    value={item}
                                    control={<Radio size='small' />}
                                    label={<label style={{ fontSize: '0.875rem' }}>{item}</label>}
                                />
                            ))}
                        </RadioGroup>
                        <Box width='80%' mx='auto' my={3}>
                            <TextField
                                label='Comments'
                                InputLabelProps={{ shrink: true, color: 'primary' }}
                                multiline
                                rows={2}
                                fullWidth
                                value={comment}
                                onChange={handleComment}
                                disabled={!reason}
                            />
                        </Box>
                    </Box>
                    <Button variant='contained' disabled={!comment} onClick={handleSubmit}>
                        Submit
                    </Button>
                </>
            )}
        </div>
    );
};

export default OfferRejected;
